export default "__VITE_ASSET__By65Du2i__"